var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbVectorGrayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-vector-gray-icon_svg__clip0_1326_2495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5a8 8 0 00-8 8 1 1 0 11-2 0C0 4.977 4.477.5 10 .5a9.969 9.969 0 017 2.859V2.5a1 1 0 112 0v3.87a1 1 0 01-1.212.977l-4-.87a1 1 0 01.425-1.954l1.436.312A7.974 7.974 0 0010 2.5zm9 7a1 1 0 011 1c0 5.523-4.477 10-10 10a9.969 9.969 0 01-7-2.859v.859a1 1 0 01-2 0v-3.87a1 1 0 011.213-.977l4 .87a1 1 0 11-.426 1.954l-1.436-.312A8 8 0 0018 10.5a1 1 0 01.999-1z",
    fill: "#58647A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-vector-gray-icon_svg__clip0_1326_2495"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(180 10 10.25)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbVectorGrayIcon;